import { Component, Input, OnInit } from '@angular/core';
import {
  integrationPermissionsListCanvas,
  integrationPermissionsListBrightspace,
} from './integration-permissions-list';
import { EnvironmentService } from '@services/environment.service';
import { FormControl } from '@angular/forms';
@Component({
    selector: 'app-integration-permissions',
    templateUrl: './integration-permissions.component.html',
    styleUrl: './integration-permissions.component.scss',
    standalone: false
})
export class IntegrationPermissionsComponent implements OnInit {
  private _data: any = {};

  @Input()
  get data(): any {
    return this._data;
  }

  set data(value: any) {
    this._data = value;
    switch (this.data.integration?.json_data?.lms_type) {
      case 'canvas':
        this.integrationPermissionsList = integrationPermissionsListCanvas;
        this.showAccountPermissions = true;
        break;
      case 'brightspace':
        this.integrationPermissionsList = integrationPermissionsListBrightspace;
        this.showAccountPermissions = false;
        this.displayOptions = [
          {
            text: 'All',
            value: 'all',
          },
          {
            text: 'Missing',
            value: 'missing',
          },
        ];
        break;
      default:
        this.integrationPermissionsList = {};
        break;
    }
  }
  showAccountPermissions = true;
  size = 'wide';
  permissions: any = [];
  integrationPermissionsList: any;
  displayOptions: any = [
    {
      text: 'All',
      value: 'all',
    },
    {
      text: 'Missing',
      value: 'missing',
    },
    {
      text: 'Missing Required',
      value: 'required',
    },
  ];
  display: 'all' | 'missing' = 'all';
  displayControl: any = new FormControl('all');

  constructor(private environmentService: EnvironmentService) {}
  ngOnInit(): void {
    const rootPermissions =
      this.data.integration?.json_data?.permission_details?.rootPermissions ||
      {};
    const accountPermissions =
      this.data.integration?.json_data?.permission_details?.accountPermissions;
    if (rootPermissions || accountPermissions) {
      this.environmentService
        .getInstanceDetails()
        .subscribe((instanceDetails: any) => {
          this.permissions = Object.keys(this.integrationPermissionsList)
            .map(key => ({
              name: key,
              title: this.integrationPermissionsList[key].title,
              reason:
                this.integrationPermissionsList[key].reason[
                  instanceDetails.scaffoldType
                ],
              account: this.checkPermission(
                key,
                'account',
                instanceDetails.scaffoldType,
                accountPermissions
              ),
              root: this.checkPermission(
                key,
                'root',
                instanceDetails.scaffoldType,
                rootPermissions
              ),
              root_context: this.integrationPermissionsList[key].root_context,
              account_context:
                this.integrationPermissionsList[key].account_context,
              service: this.integrationPermissionsList[key].service,
            }))
            .filter((permission: any) => {
              return permission.root || permission.account;
            });
        });
    }
    this.displayControl.valueChanges.subscribe((value: any) => {
      this.display = value;
    });
  }

  checkPermission(
    permission: any,
    type: 'account' | 'root',
    scaffoldType: string,
    permissions: any
  ) {
    let hasPermission: string | null = null;
    let required =
      this.integrationPermissionsList[permission]?.required?.[type];
    let optional =
      this.integrationPermissionsList[permission]?.optional?.[type];
    if (optional) {
      if (optional.includes(scaffoldType)) {
        hasPermission = permissions?.[permission] ? 'available' : 'optional';
      }
    }
    if (required) {
      if (required.includes(scaffoldType)) {
        hasPermission = permissions?.[permission] ? 'available' : 'required';
      }
    }
    return hasPermission;
  }
}
